const RulesQueryKeys = {
  global: ["rules"] as const,
};

export { RulesQueryKeys };
